import {Button} from '@kidslabs/mario-ui-nextjs-react-core';
import {Keywords} from '__generated__/__types__';
import Link from '@/_application/core/components/ui/link';

export const PopularKeywordsItem = ({tag_url, tag_name}: Keywords) => {
    if (!tag_url) return <></>;

    return (
        <Button
            className="group mr-2 mt-3 inline-block rounded-[20px] bg-white px-2.5 py-1.5 text-xs capitalize
  text-primary shadow-[2px_2px_8px_0px_#8f8f8f40] transition-colors hover:bg-primary
  md:mr-2.5 md:px-[12px] md:py-[8px] md:text-sm"
            size="small"
            aria-label="Từ khóa phổ biến"
            whileTap={{scale: 0.95}}>
            <Link href={tag_url} className="text-primary transition-colors group-hover:text-white!">
                {tag_name}
            </Link>
        </Button>
    );
};
